"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _I18n = _interopRequireDefault(require("I18n"));

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _ShareUsers = _interopRequireDefault(require("./ShareUsers"));

var _UICopyInput = _interopRequireDefault(require("UIComponents/input/UICopyInput"));

var _UIDialogBody = _interopRequireDefault(require("UIComponents/dialog/UIDialogBody"));

var _UIDialogCloseButton = _interopRequireDefault(require("UIComponents/dialog/UIDialogCloseButton"));

var _UIDialogHeader = _interopRequireDefault(require("UIComponents/dialog/UIDialogHeader"));

var _UIForm = _interopRequireDefault(require("UIComponents/form/UIForm"));

var _UIFormControl = _interopRequireDefault(require("UIComponents/form/UIFormControl"));

var _UIModal = _interopRequireDefault(require("UIComponents/dialog/UIModal"));

var _UISettings = _interopRequireDefault(require("composer-lib/data/model/UISettings"));

var _Users = _interopRequireDefault(require("composer-lib/data/model/Users"));

var _H = _interopRequireDefault(require("UIComponents/elements/headings/H2"));

var _default = (0, _createReactClass.default)({
  displayName: "ShareModal",
  propTypes: {
    compositionId: _propTypes.default.number,
    dismissShareModal: _propTypes.default.func.isRequired,
    uiSettings: _propTypes.default.instanceOf(_UISettings.default).isRequired,
    users: _propTypes.default.instanceOf(_Users.default).isRequired
  },
  dismissShareModal: function dismissShareModal() {
    this.props.dismissShareModal();
  },
  renderShareLink: function renderShareLink() {
    return _react.default.createElement(_UIFormControl.default, {
      label: _I18n.default.text('composer-lib.shareModal.link'),
      className: "share-link"
    }, _react.default.createElement(_UICopyInput.default, {
      value: window.location.href
    }));
  },
  renderShareUsers: function renderShareUsers() {
    return _react.default.createElement(_ShareUsers.default, {
      compositionId: this.props.compositionId,
      users: this.props.users
    });
  },
  render: function render() {
    if (!this.props.uiSettings.showShareModal) {
      return null;
    }

    return _react.default.createElement(_UIModal.default, {
      className: "share-modal",
      width: 540
    }, _react.default.createElement(_UIDialogHeader.default, null, _react.default.createElement(_UIDialogCloseButton.default, {
      onClick: this.dismissShareModal
    }), _react.default.createElement(_H.default, null, _react.default.createElement(_FormattedHTMLMessage.default, {
      message: "composer-lib.shareModal.header"
    }))), _react.default.createElement(_UIDialogBody.default, {
      className: "share-modal-body"
    }, _react.default.createElement("p", null, _react.default.createElement(_FormattedHTMLMessage.default, {
      message: "composer-lib.shareModal.body"
    })), _react.default.createElement(_UIForm.default, null, this.renderShareLink(), _react.default.createElement("hr", null), this.renderShareUsers())));
  }
});

exports.default = _default;
module.exports = exports.default;